import React, {PropTypes} from 'react';
import StandardModal from 'shared/StandardModal.jsx';

const RequiredProfileFieldsModal = ({
  visible,
  message,
  onSubmit,
  onCancel
}) =>(
  <StandardModal
    title={`Missing Required Profile Fields`}
    visible={visible}
    onCloseClick={onCancel}>
      <div>
        <div>
            <p>{message}</p>
        </div>
        <div className="form-group text-right">
            <button
            type="button"
            className="btn btn-link"
            onClick={() => onCancel()}
            >Cancel</button>
            {` `}
            <button
            onClick={() => onSubmit()}
            className="btn btn-primary btn-lg"
            ><i className="fa fa-floppy-o" /> {'OK'}</button>
        </div>
      </div>
    </StandardModal>
);

RequiredProfileFieldsModal.propTypes = {
    visible: PropTypes.bool,
    message: PropTypes.string,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func
};

RequiredProfileFieldsModal.defaultProps = {
    visible: false,
    message: ''
};

export default RequiredProfileFieldsModal;


// WEBPACK FOOTER //
// ./src/features/registration/home/RequiredProfileFieldsModal.jsx